<template>

  <Card class="p-col">
    <template #title>
      <div class="p-d-flex p-jc-between">
        <div>
          <h3 class="p-m-0"><strong>{{ _t('label_system_tables_columns') }}</strong></h3>
        </div>
        <div>
          <Button v-if="canBeEdited" v-tooltip.bottom="_t('Cancel')"
                  class="p-button-rounded p-button-danger p-button-text" icon="pi pi-times"
                  @click="canBeEdited = false"/>
          <Button
              v-tooltip.bottom="canBeEdited ? _t('Save') :_t('Edit')"
              :class="canBeEdited ? 'p-button-rounded p-button-text p-button-success' : 'p-button-rounded p-button-text p-button-secondary' "
              :disabled="savingColumns"
              :icon="canBeEdited ? 'pi pi-check' : 'pi pi-pencil'"
              :loading="savingColumns"
              @click="processEditing"
          />
        </div>
      </div>
    </template>
    <template #content>
      <TabPanel
          :header="_t('label_view')"
      >
        <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
          <Card v-for="(element,key) in orgColsData"
                :key="key"
                class="style p-col"
                style="padding: 5px 20px; min-width: 410px; max-width: 410px;">
            <template #title>
              <h3>
                <strong>{{ _t(getTitle(key)) }}</strong>
              </h3>
            </template>
            <template #content>
              <div style="display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center;">
                <div v-for="(item) in element" :key="item.value + item.label" class="field-checkbox"
                     style="width: 160px; margin: 5px 0;">
                  <Checkbox v-model="item.checked"
                            :disabled="!canBeEdited" :inputId="item.value"
                            :name="item.value" :value="item.value"
                  />
                  <label :for="item.value" style="margin-left: 15px;">{{ _t(`${item.label}`) }}</label>
                </div>
              </div>
            </template>
          </Card>
        </div>
      </TabPanel>
    </template>
  </Card>

</template>
<script>


import {getOrganizationColumns, getUserColumns, setOrganizationColumns, setUserColumns} from "@/api/uiColumns";
import router from "@/router";
import { logError } from "@/utils/appLogger";
import { formatApiError } from '@/utils/apiError'
import {
  areColumnsEqual,
  buildUserColumnsFromOrganization,
  normalizeOrganizationColumns,
  normalizeUserColumns
} from "@/utils/uiColumnsNormalizer";

export default {
  name: 'test',
  data: () => ({
    canBeEdited: false,
    orgColsData: normalizeOrganizationColumns(),
    userColsData: normalizeOrganizationColumns(),
    savingColumns: false,
  }),
  mounted() {
    if (localStorage.getItem('GCOP') !== 'true') {
      router.push('/')
      return
    }

    this.loadColumns()
  },
  methods: {
    async loadColumns() {
      let organizationColumnsLoaded = false

      try {
        const organizationResponse = await getOrganizationColumns()
        const normalizedOrganizationColumns = normalizeOrganizationColumns(organizationResponse.data)

        this.orgColsData = normalizedOrganizationColumns

        if (!areColumnsEqual(organizationResponse.data, normalizedOrganizationColumns)) {
          await setOrganizationColumns(normalizedOrganizationColumns)
        }

        organizationColumnsLoaded = true
      } catch (err) {
        this.orgColsData = normalizeOrganizationColumns()
        logError('getOrganizationColumns failed', err)
      }

      try {
        const userResponse = await getUserColumns()
        const normalizedUserColumns = normalizeUserColumns(userResponse.data, this.orgColsData)

        this.userColsData = normalizedUserColumns

        if (organizationColumnsLoaded && !areColumnsEqual(userResponse.data, normalizedUserColumns)) {
          await setUserColumns(normalizedUserColumns)
        }
      } catch (err) {
        this.userColsData = normalizeUserColumns({}, this.orgColsData)
        logError('getUserColumns failed', err)
      }
    },
    async processEditing() {
      if (this.savingColumns) {
        return
      }

      if (!this.canBeEdited) {
        this.canBeEdited = true
        return
      }

      try {
        this.savingColumns = true
        await this.saveOrganizationColumnsView()
        this.canBeEdited = false
      } catch (err) {
        logError('saveOrganizationColumnsView failed', err)
        this.$root.showMessage(formatApiError(err, 'Unable to save system tables', ': '), 'error')
      } finally {
        this.savingColumns = false
      }
    },
    async saveOrganizationColumnsView() {
      const normalizedOrganizationColumns = normalizeOrganizationColumns(this.orgColsData)
      this.orgColsData = normalizedOrganizationColumns

      const response = await setOrganizationColumns(normalizedOrganizationColumns)
      const savedOrganizationColumns = normalizeOrganizationColumns(response?.data || normalizedOrganizationColumns)
      const newUserColumns = buildUserColumnsFromOrganization(this.userColsData, savedOrganizationColumns)

      this.orgColsData = savedOrganizationColumns
      this.userColsData = newUserColumns

      await setUserColumns(newUserColumns)
    },
    getTitle(title) {
      if (title === 'alarmParticipantGroupsItems') return 'PARTICIPANT_GROUP'
      if (title === 'teamMediaSchedulesItems') return 'PARTICIPANT_ROTATIONAL_CAL'
      if (title === 'standbySchedulesItems') return 'label_ap_rotationals'
      if (title === 'alarmParticipantPlansItems') return 'label_alarm_plans'
      if (title === 'alarmParticipantsItems') return 'label_participants'
      if (title === 'alarmPointItems') return 'menu.alarm_definition.new'
      if (title === 'alarmTableItems') return 'label_alarmtable'
    },
  },
}
</script>

<style scoped>

</style>
